import { ApiError } from '../../abstract/api-error';
import { isRecord } from './is-record';

/**
 * Whether a caught error is the hub's Pro-membership gate (`code: 'pro_required'`, a 403 with
 * `action: 'upgrade'`), as opposed to some other 403 the endpoint might return for an unrelated reason
 * (an auth/policy failure must surface as a real error, not redirect to the upgrade page).
 *
 * Accepts an `ApiError` (services on `BaseService`) or a raw `HttpErrorResponse` (services still calling
 * `HttpClient` directly), which is mapped through `ApiError.fromHttpError`. Until every caller is
 * migrated it also accepts the legacy `{ error: 'pro_required' }` 403 body.
 *
 * Lives in its own Angular-free file so specs can import the real function a service's catch block calls.
 */
export function isProRequiredError(error: unknown): boolean {
  return ApiError.fromHttpError(error).code === 'pro_required' || isLegacyProRequired(error);
}

/** The pre-envelope gate body, `{ error: 'pro_required' }` on a 403. */
function isLegacyProRequired(error: unknown): boolean {
  if (!isRecord(error) || error['status'] !== 403 || !isRecord(error['error'])) {
    return false;
  }
  return error['error']['error'] === 'pro_required';
}
